import { useMemo } from 'react';
import { schnellchatDokument } from '../schnellchat-html';
export default function SchnellbuehnePanel({ html }: { html: string }) {
  const doc = useMemo(() => schnellchatDokument(html), [html]);
  return <iframe title="Schnellbühne" sandbox="" referrerPolicy="no-referrer" srcDoc={doc} style={{ width: '100%', height: '100%', border: 0, display: 'block', background: 'white' }} />;
}
